const axios = require('axios')

const api = axios.create({
  baseURL: process.env.API_ROOT,
  headers: { 'Accept': 'text/plain' }
})

export default {
  /**
   * Load application data from CMS API
   * @param  {Integer} suiteId
   * @return {Promise}
   */
  load: async (suiteId) => {
    const suite = await api.get(`/suites/${suiteId}`)
    const animals = await getAnimals(suite.data.data.animalIds)

    return {
      suite: suite.data.data,
      animals
    }
  },

  /**
   * Load recently adopted animals data from CMS API
   * @param  {String}  species
   * @param  {Number} limit
   * @return {Promise}
   */
  loadRecentlyAdopted: async (species, limit = 8) => {
    const response = await api.get(`/adoptedanimals?species=${species}&limit=${limit}`)
    return response.data.data
  }
}

/**
 * Get animals from array of animal ids
 * @param  {Array} ids
 * @return {Promise}
 */
function getAnimals (ids) {
  return new Promise((resolve, reject) => {
    const queue = []
    const results = []

    ids.forEach(id => {
      queue.push(api.get(`/animals/${id}`))
    })

    Promise.all(queue)
      .then(data => {
        data.forEach(result => {
          results.push(result.data.data)
        })

        resolve(results)
      })
  })
}



// WEBPACK FOOTER //
// ./src/store/api.js